import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { LoadingSymbolComponent } from './loading-symbol.component';

@NgModule({
    declarations: [LoadingSymbolComponent],
    exports: [LoadingSymbolComponent],
    imports: [CommonModule],
})
export class LoadingSymbolModule {}
